<template>
    <div id="listCharge">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                 <div class="page-name">
                     <div class="page-title"> Tax List</div>
                    <router-link v-if="canAdd" class="btn btn-primary pull-right" v-bind:to="{name: 'createTax'}" >
                        <i class="fp-add"> </i>  Add
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-list">
                        <data-table-filter-config :moduleName="'TaxList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'TaxList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="listTaxTable"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Taxes"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                        :sort-options="{
                                    enabled: true,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdate">
                                                    <router-link class="fp-edit" v-bind:to="{name: 'editTax',params:{id:props.row.id}}" title="Update Tax">
                                                    </router-link>
                                                </template>
                                                <a v-if="!hidden">|</a>
                                                <!-- <a href="javascript:void(0)" class="fp-remove" v-on:click="deleteCharge(props.row.id,key)" v-if="!hidden" title="Remove Charge"></a> -->
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>


    import Vue from 'vue';

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "listTax",
        metaInfo() {
            return {title: "Tax List | FleetPro Application"}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({

            firstLoad : 0,
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    html: true,
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Tax Name',
                    field: 'tax_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Tax Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Code',
                    field: 'code',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "tax Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Percentage',
                    field: 'percentage',
                    hidden:false,
                    fpFieldType:"integer",
                    filterable: true,
                    html: false,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Percentage", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],// dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State',
                    field: 'state',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Gl Account Code',
                    field: 'gl_account_code',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Gl Account Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            permissions:[],
            loading:false,
            hidden:true,
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_tax') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'add_tax') {
                        self.canAdd = true;
                        self.canUpdate = true;
                    }
                });
                if(self.cantAccess == ''){
                    self.cantAccess = false;
                }
            }
        },
        created: function() {
            this.serverParams.sort = {field:"id",type:"desc"};
        },
        mounted: function () {

            this.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listTaxTable.unselectAllInternal();
            },

            loadList: function(){
                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/tax/list",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: this.serverParams.sort,
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;

                            self.perPage = data.content.perPage;
                            // if (data.content.totalRecords == 0){
                            //     self.rows = 0;
                            // }
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'list-tax-data')

                    }
                });
            },
            // deleteTax:function(id,index){
            //     var self = this;
            //     console.log(id);

            //     if(confirm("Are You Sure You Want To Delete This Tax?")){
            //         $.ajax({
            //             url: process.env.API + "/" + process.env.VERSION + "/remove_tax",
            //             type: "POST",
            //             data: 'id='+id,
            //             headers: {
            //                 'Accept': 'application/json',
            //                 "Authorization": "Bearer "+localStorage.getItem("tkn"),
            //                 'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            //                 "Cache-Control": "no-cache"
            //             },
            //             dataType: 'json',
            //             success: function (data) {
            //                 if (data.code == 200) {
            //                     console.log(data.message);
            //                     self.loadList();
            //                     self.rows = data.content.row;
            //                     self.totalRecords = data.content.totalRecords;

            //                 }
            //             },
            //             error: function (jqXHR, exception) {
            //                 self.generateStatusCodeMessage(jqXHR,false,'delete-tax-data')
            //             }

            //         });

            //     }
            // }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/tax/TaxList.vue